export enum RelevanceScore {
    NotScored = 'NotScored',
    NotRelevant = 'NotRelevant',
    Relevant = 'Relevant',
    HighlyRelevant = 'HighlyRelevant',
}
